import * as Types from '../generated/types';

import { gql } from '@apollo/client';
export type DriverNodeFragment = { __typename?: 'DriverNode', id: string, address?: string | null, additionalAddress?: string | null, city?: string | null, zip?: number | null, country?: string | null, phone?: string | null, name: string, email?: string | null, idNumber?: string | null, birthday?: any | null, customer: { __typename?: 'CustomerNode', id: string, name: string } };

export const DriverNodeFragmentDoc = gql`
    fragment DriverNode on DriverNode {
  id
  address
  additionalAddress
  city
  zip
  country
  phone
  name
  email
  idNumber
  birthday
  customer {
    id
    name
  }
}
    `;